import { TDeviceType } from '@cian/ui-kit';

import { TJsonQuery } from '../../../../packages/JsonQuery';
import { setSort } from '../../../../packages/JsonQuery/setSort';
import { EKey } from '../../repositories/dailyrent/entities/sort_variant/SortVariant';
import { selectJsonQuery } from '../../selectors/filters/selectJsonQuery';
import { TThunkAction } from '../../types/redux';
import { TSortKey } from '../../utils/sort/sortMapping';
import { fetchHybridSearchData } from '../fetchHybridSearchData';
import { justChangeJsonQuery } from '../filters/justChangeJsonQuery';

interface IApplySortArgs {
  sortKey: TSortKey;
  deviceType: TDeviceType;
}

/**
 * Применяет выбранный вариант сортировки: маппит TSortKey -> ESortValue в JSON-Query
 * и перезагружает выдачу со сбросом страницы. 'default' сбрасывает sort-терм.
 */
export const applySort =
  ({ sortKey, deviceType }: IApplySortArgs): TThunkAction<Promise<void>> =>
  async (dispatch, getState) => {
    const jsonQuery = selectJsonQuery(getState()) as TJsonQuery;
    const nextJsonQuery = setSort(jsonQuery)(sortKey === EKey.Default ? null : sortKey);

    dispatch(justChangeJsonQuery({ nextJsonQuery }));

    await dispatch(fetchHybridSearchData({ mode: 'reset', updateBounds: false, deviceType }));
  };
